import { Component } from '@angular/core';

@Component({
    selector: 'app-audience-tab-root',
    templateUrl: './audience-tab-root.component.html',
    styleUrls: ['./audience-tab-root.component.scss'],
})
export class AudienceTabRootComponent {}
